/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:12:06
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-30 10:14:29
 */
import req from "@/utils/request";

//  get 请求示列
export const selectPage = (params) => req.post("/media-service/m/msMedia/selectListCountPage", params);
export const countMedia = (params) => req.post("/media-service/m/msMedia/countMedia", params);
